<template>
  <div
    ref="container"
    class="inline-flex overflow-hidden xl:!w-max xl:overflow-visible"
    :style="{ width: containerWidth }"
  >
    <div ref="wrapper" :class="wrapperClasses">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { sleep } from '@libs/utils';
import { useElementSize } from '@vueuse/core';

type TextHorizontalScrollProps = {
  containerWidth: string;
};

defineProps<TextHorizontalScrollProps>();

const container = ref<HTMLElement>();
const wrapper = ref<HTMLElement>();
const wrapperClasses = ref<string>('');
const { width: symbolNameWrapperWidth } = useElementSize(wrapper);

watch(
  symbolNameWrapperWidth,
  async () => {
    wrapperClasses.value = '';

    await sleep();

    if (
      wrapper.value &&
      container.value &&
      wrapper.value?.clientWidth > container.value.clientWidth
    ) {
      wrapperClasses.value = ' animate-infinite-horizontal-scroll';
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.animate-infinite-horizontal-scroll {
  @apply animate-[infinite-horizontal-scroll_10s_linear_infinite];
}

@keyframes infinite-horizontal-scroll {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
